import en_resource from './lang/en';
import es_resource from './lang/es';
import ar_resource from './lang/ar';

// let it_resource = {
//     title: "Applicazione multilingue",
//     label: "Selezionare un'altra lingua ",
//     about: "Su di me",
//     home: "Casa",
// }

export const resource = {
	en: {
		translation: en_resource
	},
	es: {
		translation: es_resource
	},
	ar: {
		translation: ar_resource
	}
};
